import { render } from "./BaseNoResultMessage.vue?vue&type=template&id=fa62295c&scoped=true"
import script from "./BaseNoResultMessage.vue?vue&type=script&lang=js"
export * from "./BaseNoResultMessage.vue?vue&type=script&lang=js"

import "./BaseNoResultMessage.vue?vue&type=style&index=0&id=fa62295c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa62295c"]])

export default __exports__